module.exports = __webpack_public_path__ + "img/download-btn.70c19845.svg";